import { useQuery } from '@tanstack/react-query';

export default function useApiQuery(key, fetchFn, options = {}) {
  const { data, isLoading, error, refetch, ...rest } = useQuery({
    queryKey: key,
    queryFn: fetchFn,
    ...options,
  });

  return {
    data,
    isLoading,
    error,
    refetch,
    ...rest,
  };
}
